import { AfterViewInit, Directive, Input, OnDestroy, Output, inject } from '@angular/core';
import { FormControlStatus, NgForm } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';

@Directive({
  selector: 'form[irisFormValid]',
})
export class IrisFormValidDirective implements AfterViewInit, OnDestroy {
  private readonly _form = inject(NgForm);

  @Input('irisFormValid') irisFormValidInput: Subject<boolean>;
  @Output() readonly irisFormValid = new ReplaySubject<boolean>(1);

  private readonly _destroyed$ = new Subject<void>();

  ngAfterViewInit(): void {
    this._startNotifyingAboutFormValidChanges();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  private _startNotifyingAboutFormValidChanges() {
    this._form.statusChanges.pipe(
      // Two events are fired if attribute 'required' changes on the fly.
      // And we need only the latest one.
      debounceTime(50),
      tap((event: FormControlStatus) => {
        if (event == 'VALID') {
          this._notify(true);
        } else if (event == 'INVALID') {
          this._notify(false);
        }
      }),
      takeUntil(this._destroyed$),
    ).subscribe();
  }

  private _notify(valid: boolean) {
    this.irisFormValid.next(valid);

    if (this.irisFormValidInput) {
      this.irisFormValidInput.next(valid);
    }
  }
}
